import React, { useEffect, useRef } from "react";
import TextBlock from './textBlock';
import CardsBlock from "./cardsBlock";
import { textBlocks, headers, cardsData, cardsData2 } from '../data';
import './teamBlock.css';

export default function TeamBlock() {
    return(
        <div className="container">
            <div className="teamBlock">
                <TextBlock title={textBlocks[1].title} text={textBlocks[1].text} class={textBlocks[1].class} />
                <h2 className="textBlue">{headers[3].header}</h2>
                <CardsBlock cards={ cardsData } />
                <h2 className="textBlue">{headers[4].header}</h2>
                <CardsBlock cards={ cardsData2 } />
                <TextBlock title={textBlocks[2].title} text={textBlocks[2].text} />
            </div>
        </div>
    )
}